export default [
  { prop: 'data.artist', header: 'Artist' },
  { prop: 'data.genre', header: 'Genre' },
  { prop: 'data.country', header: 'Country' },
  { prop: 'data.likes', header: 'Likes' },
  { prop: 'data.rating', header: 'Rating' },
  { prop: 'data.raters', header: 'Raters' },
]
